/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addEmailRestrictions,
  getEmailRestrictions,
} from "../../../../api/User";
import { UserAtom } from "../../../../atoms/UserAtom";
import { UserEmailRestrictionsAtom } from "../../../../atoms/UserEmailRestrictionsAtom";
import StyledBlockInput, { BlockInputType } from "../../../StyledBlockInput";

export default function BlockDeviceID() {
  const [isLoading, setIsLoading] = useState(false);
  const setEmailRestrictions = useSetRecoilState(UserEmailRestrictionsAtom);
  const [user, setUser] = useRecoilState(UserAtom);

  async function handleBlockDeviceId(deviceIds: string[]) {
    setIsLoading(true);

    try {
      await addEmailRestrictions({ deviceIdsBlocked: deviceIds });

      toast("Success", { type: "success" });
      const emailRestrictions = await getEmailRestrictions();
      setEmailRestrictions(emailRestrictions);
      setUser({ ...user, emailRestrictions });
    } catch {
      toast("Error", { type: "error" });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <StyledBlockInput
      handleClick={handleBlockDeviceId}
      isLoading={isLoading}
      inputType={BlockInputType.DeviceId}
      placeholder="Enter device ID"
      isValid={(value: string) => {
        const isValid = value.length > 20;
        if (!isValid) return `${value} is not a valid id.`;
        return "";
      }}
    />
  );
}
